<template>
    <div class="login-body">
        <div class="login-main">
            <div class="login-main-left">
              <div class="login-logo"></div>
              <p class="login-title">值  得  托  付  的  IT  管  家</p>
            </div>
            <div class="login-main-right">
                 <div class="layui-form">
                    <div class="title">
                        <span style="cursor:pointer;" @click="tabClick(1)" :class="{'login-active' : loginType == 1, 'login-deactive': loginType == 2}">密码登录</span>
                        <span style="cursor:pointer;padding-left:10px" @click="tabClick(2)" :class="{'login-active' : loginType == 2, 'login-deactive': loginType == 1}">短信登录</span>
                    </div>
                    <div class="layui-form-item" v-show="loginType == 1">
                        <label class="layui-form-label">用户名</label>
                        <input type="text" placeholder="请输入用户名" class="layui-input" v-model='u' autocomplete="off">
                    </div>
                    <div class="layui-form-item" v-show="loginType == 1">
                        <label class="layui-form-label">密码</label>
                        <input type="password" placeholder="请输入密码" class="layui-input" v-model='p' id="ps" autocomplete="off">
                        <input type="text" placeholder="请输入密码" class="layui-input" v-model='p' id="ps2" autocomplete="off" style="display: none">
                        <a id="passwordeye" class="invisible"></a>
                    </div>
                    <div class="layui-form-item" v-show="loginType == 2">
                        <label class="layui-form-label">手机号</label>
                        <input type="text" placeholder="请输入手机号" class="layui-input" v-model='phone' autocomplete="off">
                    </div>
                    <div class="layui-form-item" v-show="isShow">
                        <label class="layui-form-label">验证码</label>
                        <input type="text" placeholder="请输入验证码" class="layui-input" v-model='c' autocomplete="off">
                        <div class="v-code">
                            <img v-bind:src="captcha_url" class="layadmin-user-login-codeimg"  @click="refreshCaptcha()">
                        </div>
                    </div>
                    <div class="layui-form-item" v-show="!isShow"></div>
                    <div class="layui-form-item" v-show="loginType == 2">
                        <label class="layui-form-label">短信验证码</label>
                        <input type="text" placeholder="短信验证码" class="layui-input" v-model='msgCode' autocomplete="off">
                        <div class="v-code" style="background: #00489E;line-height: 40px;text-align: center;cursor:pointer" @click="sendMessage()">
                             <span style="color:white" v-show="!msgSend">{{sendText}}</span>
                             <span style="color:white" v-show="msgSend">已发送 <span>{{tickTime}}</span>s</span>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <button class="layui-btn layui-btn-fluid" @click="doLogin()">登 录</button>
                    </div>
                 </div>
            </div>
        </div>
        <div class="login-footer">
            <!-- <span>主办单位：xx</span>
            <span style="padding-left: 98px;">联系电话：xx</span> -->
        </div>
    </div>
</template>

<script>
import "../../static/style/login.css";
import request from '../network/networkconfig';
export default {
    name: 'Login',
    data () {
        return {
            captcha_url: null,
            u: null,
            p: null,
            c: null,
            phone: null,
            msgCode: null, //短信验证码
            loginType: '1', // 1、密码登录 2、短信登录
            tickTime: 60,
            msgSend: false,
            sendText: '发送验证码',
            isShow: false
        }
    },
    mounted() {
        this.refreshCaptcha();
        window.history.pushState({},0, this.dict.constants.LOGIN_PAGE_PATH);

        $(document).keypress((e)=> {
            var eCode = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
            if (eCode == 13){
                this.doLogin();
            }
        });

        $("#passwordeye").on("click","",function () {
            if($(this).attr("class").indexOf("invisible")>-1){
                $(this).removeClass("invisible").addClass("visible");
                $("#ps").hide();
                $("#ps2").show();
            }else{
                $(this).removeClass("visible").addClass("invisible");
                $("#ps").show();
                $("#ps2").hide();
            }
	    });
    },
    activated() {
        window.history.pushState({},0, this.dict.constants.LOGIN_PAGE_PATH);
        this.u = null;
        this.p = null;
        this.c = null;
        this.refreshCaptcha();
        this.tabClick(1);
        if (window.reloginConfirm) {
             // 请求中有tid,但是tid的值已经失效或者验证不通过
            layui.layer.confirm('检测到您登录凭证已经失效，需要重新登录！', {btn: ['确定', '取消']},
            ()=> {
                window.reloginConfirm = false;
                $('.layui-layer-btn1').trigger('click');
            },
            ()=> {
                window.reloginConfirm = false;
            });
        }
    },
    methods: {
        doLogin() {
            if(this.loginType == 1) {
                if(!this.u) {
                    this.layer.openAlert('请输入用户名！', false);
                    return;
                }
                if(!this.c && this.isShow) {
                    this.layer.openAlert('请输入验证码！', false);
                    return;
                }
                if(!this.p) {
                    this.layer.openAlert('请输入密码！', false);
                    return;
                }
                var base64= new Base64();
                var u = base64.encode(this.u);
                var p = base64.encode(this.p);
                this.security
                .loginCaptcha(u, p, this.c)
                .then((result)=> {
                    if(result.errorCode) {
                    //用户名密码登录时，失败超过七次需要验证码登录
                    var faileCount = result.details.failedCount;
                    if(faileCount>=7){
                        this.isShow = true;
                    };
                        this.layer.openAlert(result.errorMsg, false);
                        this.refreshCaptcha();
                    } else {
                        // 登录成功
                        var resultInfo = result.result;
                        this.security.setUser(resultInfo.token, resultInfo.uid, resultInfo.uaccount, resultInfo.uname, resultInfo.zqcode, resultInfo.orgid,
                        resultInfo.roles ? resultInfo.roles.split(',') : [],
                        resultInfo.marks ? resultInfo.marks.split(',') : [],
                        resultInfo.f_token, resultInfo.zqName, resultInfo.rolenames,
                        resultInfo.fId);
                        this.$bus.$emit(this.dict.event.LOGIN_SUCCESS);
                        this.isShow = false;
                    }
                })
                .catch((error)=>{
                    this.layer.openAlert(error.message);
                });;
            } else if(this.loginType == 2) {
                if(!this.phone) {
                    this.layer.openAlert('请输入手机号！', false);
                    return;
                }
                if(!this.ruleObj.getRuleMethod('phone')('phone', {phone: this.phone})){
                    this.layer.openAlert("请输入正确的手机号", false);
                    return;
                }
                if(!this.c && this.isShow) {
                    this.layer.openAlert('请输入验证码！', false);
                    return;
                }
                if(!this.msgCode) {
                    this.layer.openAlert('请输入短信验证码！', false);
                    return;
                }
                var base64= new Base64();
                var phone = base64.encode(this.phone);
                var captcha = this.isShow? base64.encode(this.c): "";
                let data = new FormData();
                data.append("phone",  phone);
                data.append("msgCode",  this.msgCode);
                data.append("captcha",captcha);
                data.append("type",  2);
                request({
                    url: '/login/auth',
                    method: 'post',
                    data: data
                }).then((result)=> {
                    this.msgCode = null;
                    this.c = null;
                    if(result.errorCode) {
                      //用户名密码登录时，失败超过七次需要验证码登录
                      var faileCount = result.details.failedCount;
                      if(faileCount>=7){
                        this.isShow = true;
                      };
                        this.layer.openAlert(result.errorMsg, false);
                        this.refreshCaptcha();
                    } else {
                        // 登录成功
                        var resultInfo = result.result;
                        this.security.setUser(resultInfo.token, resultInfo.uid, resultInfo.uaccount, resultInfo.uname, resultInfo.zqcode, resultInfo.orgid,
                        resultInfo.roles ? resultInfo.roles.split(',') : [],
                        resultInfo.marks ? resultInfo.marks.split(',') : [],
                        resultInfo.f_token, resultInfo.zqName, resultInfo.rolenames);
                        this.$bus.$emit(this.dict.event.LOGIN_SUCCESS);
                        this.isShow = false;
                    }
                })
                .catch((error)=>{
                    this.layer.openAlert(error.message);
                });;
            }

        },
        refreshCaptcha() {
            this.c = null;
            if(this.isShow){
                this.captcha_url =  process.env.API_HOST +  '/captcha/word?_t=' + new Date().getTime();
            }
        },
        tabClick(loginType){
            this.loginType = loginType;
            this.refreshCaptcha();
            this.msgSend = false;
            this.tickTime = 60;
            this.msgCode = null;
            if(this.interval) {
                window.clearInterval(this.interval)
            }
        },
        //发送验证码
        sendMessage(){
            this.msgCode = null;
            if(!this.phone) {
                this.layer.openAlert('请输入手机号！', false);
                return;
            }
            if(!this.ruleObj.getRuleMethod('phone')('phone', {phone: this.phone})){
                this.layer.openAlert("请输入正确的手机号", false);
                return;
            }
            if(!this.c && this.isShow) {
                this.layer.openAlert("请先输入验证码", false);
                return;
            }
            if(!this.msgSend) {
              request({
                    url: '/login/sendMsg/' + this.c+  '/' + this.phone,
                    method: 'post',
                }).then((result) => {
                     if(result.errorCode) {
                        this.layer.openAlert(result.errorMsg, false);
                        this.refreshCaptcha();
                    } else {
                        this.msgSend = true;
                        this.interval = setInterval(()=> {
                            this.tickTime--;
                            if(this.tickTime == 0) {
                                if(this.interval) {
                                    window.clearInterval(this.interval)
                                    this.msgSend = false;
                                    this.tickTime = 60;
                                    this.sendText = '重新发送';
                                    this.msgCode = null;
                                }
                            }
                        }, 1000);
                    }
                });

            }
        }
    }
}

</script>
<style scoped>
.login-active {
    color: #00489E
}
.login-deactive{
    color: #999999
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue